<template>
  <a-row :gutter="10">
    <a-col :md="12" :sm="24">
      <a-card :bordered="false" ref="departRef" style="height: calc(100vh - 200px); overflow-y: scroll">
        <!-- 按钮操作区域 -->
        <a-row style="margin-left: 14px">
          <!--<a-button @click="handleAdd(1)" type="primary">{{$t('button.addCompany')}}</a-button>-->
          <mtc-button @click="handleAdd(1)" type="primary" text="button.addCompany"></mtc-button>
          <mtc-button @click="handleAdd(2)" type="primary" style="margin-left: 8px" text="button.addSubordinate"></mtc-button>
          <!--<a-button @click="handleAdd(2)" type="primary">{{$t('button.addSubordinate')}}</a-button>-->
          <!--<a-button type="primary" icon="download" @click="handleExportXls('部门信息')">{{-->
          <!--$t('button.export')-->
          <!--}}</a-button>-->
          <mtc-button type="primary" icon="download" style="margin-left: 8px" text="button.export" @click="handleExportXls('部门信息')"></mtc-button>
          <!--<a-button type="danger" icon="build" @click="showModal()">{{$t('button.releaseVersion')}}</a-button>-->
          <mtc-button type="danger" icon="build" style="margin-left: 8px" text="button.releaseVersion" @click="showModal()"></mtc-button>
          <!-- 发布版本的提示model -->
          <a-modal v-model="visible" :title="$t('tip.importantOperations')" @ok="handleOk">
            <p>{{ $t('tip.currentOrganizationalStructureWillBeDocumented') }}!</p>
          </a-modal>
          <!--<a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
          <!--<a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
          <!--</a-upload>-->
          <!--<a-button :title="$t('button.batchDelete')" @click="batchDel" type="default">{{$t('button.batchDelete')}}</a-button>-->
          <mtc-button type="default" :title="$t('button.batchDelete')" style="margin-left: 8px" text="button.batchDelete" @click="batchDel"></mtc-button>
          <!--<a-button @click="refresh" type="default" icon="reload" :loading="loading">刷新</a-button>-->
        </a-row>
        <div class="drawer-bootom-button">
          <a-dropdown :trigger="['click']" placement="topCenter">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="switchCheckStrictly(1)">{{ $t('button.FatherSonConnection') }}</a-menu-item>
              <a-menu-item key="2" @click="switchCheckStrictly(2)">{{ $t('button.cancelConnection') }}</a-menu-item>
              <a-menu-item key="3" @click="checkALL">{{ $t('button.selectAll') }}</a-menu-item>
              <a-menu-item key="4" @click="cancelCheckALL">{{ $t('button.unselectAll') }}</a-menu-item>
              <a-menu-item key="5" @click="expandAll">{{ $t('button.expandAll') }}</a-menu-item>
              <a-menu-item key="6" @click="closeAll">{{ $t('button.mergeAll') }}</a-menu-item>
            </a-menu>
            <mtc-button text="button.treeOperations">
              <a-icon type="up" />
            </mtc-button>
            ·
          </a-dropdown>
        </div>
        <div style="background: #fff; padding-left: 16px; height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('tip.selected') }}：<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="onClearSelected">{{ $t('button.clearSelection') }}</a>
            </div>
          </a-alert>
          <a-input-search @search="onSearch" style="width: 100%; margin-top: 10px" :placeholder="$t('label.pleaseEnterDepartmentName')" />
          <!-- 树-->
          <a-col :md="10" :sm="24">
            <template>
              <a-dropdown :trigger="[this.dropTrigger]" @visibleChange="dropStatus">
                <span style="user-select: none">
                  <a-tree
                    checkable
                    multiple
                    @select="onSelect"
                    @check="onCheck"
                    @rightClick="rightHandle"
                    :selectedKeys="selectedKeys"
                    :checkedKeys="checkedKeys"
                    :treeData="departTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand"
                  />
                </span>
                <!--新增右键点击事件,和增加添加和删除功能-->
                <a-menu slot="overlay">
                  <a-menu-item @click="handleAdd(3)" key="1">{{ $t('button.add') }}</a-menu-item>
                  <a-menu-item @click="handleDelete" key="2">{{ $t('button.delete') }}</a-menu-item>
                  <a-menu-item @click="closeDrop" key="3">{{ $t('button.cancel') }}</a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </a-col>
        </div>
      </a-card>
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
    </a-col>
    <a-col :md="12" :sm="24" style="overflow: hidden">
      <a-affix :offset-top="130" style="overflow: scroll">
        <a-tabs defaultActiveKey="1" style="height: 80vh; overflow-y: scroll">
          <a-tab-pane :tab="$t('label.basicInformation')" key="1">
            <a-card :bordered="false" v-if="selectedKeys.length > 0">
              <a-form :form="form">
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.organizationName">
                  <a-input v-decorator="['departName', validatorRules.departName]"
                           :read-only="checkField('departName')"
                           @click="openLangModal('departName', true)"
                           :placeholder="$t('label.pleaseEnterOrganizationName')" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.upperDivision">
                  <a-tree-select style="width: 100%"
                                 :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                                 :treeData="treeData"
                                 :disabled="disable"
                                 v-model="model.parentId"
                                 :placeholder="$t('label.none')" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.organizationCode">
                  <a-input :placeholder="$t('label.pleaseEnterTheOrganizationCode')"
                           :disabled="descriptionBled"
                           v-decorator="['description', validatorRules.description]" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.orgShortCode">
                  <a-input :placeholder="$t('label.PleaseEnterShortCode')"
                           :disabled="shortCodeBled"
                           v-decorator="['shortCode', validatorRules.shortCode]" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.organizationID">
                  <a-input disabled :placeholder="$t('label.pleaseEnterOrgID')" v-decorator="['orgCode']" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.personIncharge">
                  <a-select :placeholder="$t('label.pleaseSelectPersonIncharge')" v-decorator="['leaderId']">
                    <a-select-option v-for="item in leaderList" :key="item.id" :value="item.id">
                      {{ item.realname }}
                    </a-select-option>
                  </a-select>
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.divisionHead">
                  <a-select :placeholder="$t('label.pleaseSelectDivisionHead')" v-decorator="['assignerId']">
                    <a-select-option v-for="item in assignerList" :key="item.id" :value="item.id">
                      {{ item.realname }}
                    </a-select-option>
                  </a-select>
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.departAdmin">
                  <a-select :placeholder="$t('label.pleaseSelectDepartAdmin')" v-decorator="['deptAdmin']">
                    <a-select-option v-for="item in deptAdminList" :key="item.id" :value="item.id">
                      {{ item.realname }}
                    </a-select-option>
                  </a-select>
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.orgType">
                  <template v-if="orgCategoryDisabled">
                    <a-radio-group v-decorator="['orgCategory', validatorRules.orgCategory]"
                                   :placeholder="$t('label.pleaseSelectOrgType')">
                      <a-radio value="1"> {{ $t('label.company') }}</a-radio>
                    </a-radio-group>
                  </template>
                  <template v-else>
                    <a-radio-group :disabled="true"
                                   v-decorator="['orgCategory', validatorRules.orgCategory]"
                                   :placeholder="$t('label.pleaseSelectOrgType')">
                      <a-radio v-for="(item, key) in departsList" :key="key" :value="item.value">{{ item.text }}</a-radio>
                    </a-radio-group>
                  </template>
                </mtc-form-item>
                <mtc-form-item
                  v-if="orgCategoryDisabled"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="label.companyType">
                  <j-search-select-tag type="list"
                                       v-decorator="['orgType',validatorRules.orgType]"
                                       :trigger-change="true"
                                       dict="org_type"
                                       :placeholder="$t('label.companyType')" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.enabledOrNot">
                  <a-switch :checked-children="$t('label.enable')" :un-checked-children="$t('label.disable')" v-model="status" />
                </mtc-form-item>
                <!-- <mtc-form-item label="label.grower"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               v-if="farmShow == true && plantShow == true">
                  <j-search-select-tag-option-is-value-text type="list"
                                                            v-decorator="['farmerCode', validatorRules.farmerCode]"
                                                            :trigger-change="true"
                                                            dict="efs_md_farmer,name,code"
                                                            :placeholder="$t('label.pleaseSelectAdopterCode')" />
                </mtc-form-item> -->
                <mtc-form-item :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               label="label.longitude"
                               v-if="farmShow == true && plantShow == true">
                  <a-input-number v-decorator="['longitude', validatorRules.longitude]" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               label="label.latitude"
                               v-if="farmShow == true && plantShow == true">
                  <a-input-number v-decorator="['dimension', validatorRules.dimension]" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.sort">
                  <a-input-number v-decorator="['departOrder', { initialValue: 0 }]" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.cellPhoneNumber">
                  <a-input :placeholder="$t('label.pleaseInputCellPhoneNumber')" v-decorator="['mobile', { initialValue: '' }]" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               label="label.uniformCreditCode"
                               v-if="companyShow == true">
                  <a-input :placeholder="$t('label.uniformCreditCode')" v-decorator="['uscc']" />
                </mtc-form-item>
                <mtc-form-item v-if="orgCategoryDisabled"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               label="label.province">
                  <a-cascader v-model="area" :placeholder=" $t('tip.pleaseSelect')" :options="areaAllData" :fieldNames="fieldNames" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.detailedAddress">
                  <a-input :placeholder="$t('label.pleaseEnterDetailAddress')" v-decorator="['address', { initialValue: '' }]" />
                </mtc-form-item>
                <mtc-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="label.remarks">
                  <a-textarea :placeholder="$t('label.pleaseEnterANote')" v-decorator="['memo', { initialValue: '' }]" />
                </mtc-form-item>
              </a-form>
              <div class="anty-form-btn">
                <!--<a-button @click="emptyCurrForm" type="default" htmlType="button" icon="sync">{{-->
                <!--$t('button.reset')-->
                <!--}}</a-button>-->
                <!--<a-button @click="submitCurrForm" type="primary" htmlType="button" icon="form">{{$t('button.save')}}</a-button>-->
                <mtc-button @click="emptyCurrForm" type="default" htmlType="button" icon="sync" text="button.reset"></mtc-button>
                <mtc-button @click="submitCurrForm" type="primary" htmlType="button" icon="form" text="button.save"></mtc-button>
              </div>
            </a-card>
            <a-card v-else>
              <a-empty>
                <span slot="description"> {{ $t('tip.pleaseSelectDepartmentFirst') }} </span>
              </a-empty>
            </a-card>
          </a-tab-pane>
          <a-tab-pane :tab="$t('label.departmentPermissions')" key="2" forceRender>
            <depart-auth-modal ref="departAuth" />
          </a-tab-pane>
        </a-tabs>
      </a-affix>
    </a-col>
    <depart-modal ref="departModal" @ok="loadTree" />
    <mtc-lang-modal />
  </a-row>
</template>

<script>
import { areaAllData } from '@comp/_util/Area'
import { duplicateCheck } from '@/api/api'
import DepartModal from './modules/DepartModal'
import pick from 'lodash.pick'
import {
  queryDepartTreeList,
  getAddressList,
  getAllUserList,
  searchByKeywords,
  queryDepartExtend,
  ajaxGetDictItems,
  deleteByDepartId
} from '@/api/api'
import { httpAction, deleteAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DepartAuthModal from './modules/DepartAuthModal'
import JSearchSelectTagOptionIsValueText from '@/components/dict/JSearchSelectTagOptionIsValueText'
import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
import { getLanguageField, resetLangFieldMap, setLangInputParams } from '@/utils/langUtils'
import langInputMixin from '@/mixins/langInputMixin'
import { MTC_AUTH } from '@api/servers'
// 表头
const columns = [
  {
    title: '机构名称',
    dataIndex: 'departName'
  },
  {
    title: '机构类型',
    align: 'center',
    dataIndex: 'orgType'
  },
  {
    title: '机构编码',
    dataIndex: 'orgCode'
  },
  {
    title: '机构简码',
    dataIndex: 'shortCode'
  },
  {
    title: '手机号',
    dataIndex: 'mobile'
  },
  {
    title: '传真',
    dataIndex: 'fax'
  },
  {
    title: '地址',
    dataIndex: 'address'
  },
  {
    title: '负责人',
    dataIndex: 'leaderId'
  },
  {
    title: '分管领导',
    dataIndex: 'assignerId'
  },
  {
    title: '部门管理员',
    dataIndex: 'deptAdmin'
  },
  {
    title: '排序',
    align: 'center',
    dataIndex: 'departOrder'
  },
  {
    title: '操作',
    align: 'center',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  name: 'DepartList',
  mixins: [JeecgListMixin, mtcLangModalMixin, langInputMixin],
  components: {
    DepartAuthModal,
    JSearchSelectTagOptionIsValueText,
    DepartModal
  },
  data() {
    return {
      // 省市区三级联动下拉框数据
      areaAllData,
      // 省市区三级联动地址
      area: [],
      fieldNames: {
        label: 'label',
        value: 'label',
        children: 'children'
      },
      mainTable: 'sys_depart',
      tableLangFieldArr: [],
      iExpandedKeys: [],
      loading: false,
      autoExpandParent: true,
      currFlowId: '',
      currFlowName: '',
      disable: true,
      treeData: [],
      visible: false,
      departTree: [],
      rightClickSelectedKey: '',
      rightClickSelectedOrgCode: '',
      hiding: true,
      model: {},
      dropTrigger: '',
      depart: {},
      columns: columns,
      disableSubmit: false,
      checkedKeys: [],
      selectedKeys: [],
      farmShow: false,
      autoIncr: 1,
      currSelected: {},
      shortCodeBled: false,
      descriptionBled: false,
      allTreeKeys: [],
      checkStrictly: true,
      // form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      graphDatasource: {
        nodes: [],
        edges: []
      },
      validatorRules: {
        orgType: { rules: [{ required: true, message: '此项必填' }] },
        departName: { rules: [{ required: true, message: this.$t('label.pleaseEnterOrganizationName') }] },
        // orgCode: {rules: [{required: true, message: this.$t('label.pleaseEnterTheOrganizationCode')}]},
        description: { rules: [{ validator: this.validateDesc }] },
        shortCode: { rules: [{ validator: this.validateDescNew }] },
        orgCategory: { rules: [{ required: true, message: this.$t('label.pleaseSelectOrgType') }] },
        plantType: { rules: [{ required: true, message: this.$t('label.pleaseSelectFactoryType') }] },
        emptyHousePeriod: { rules: [{ required: true, message: this.$t('label.pleaseEnterDaysInStandardVacancyPeriod') }] },
        // farmerCode:{ rules: [{required: true, message: '请选择养户!'}]},
        // longitude:{ rules: [{required: true, message: '请输入经度!'}]},
        // dimension:{ rules: [{required: true, message: '请输入纬度!'}]},
        mobile: { rules: [{ validator: this.validateMobile }] },
        scale: {
          rules: [
            {
              pattern: /^\d{1,6}$/, // 正则
              message: this.$t('label.maximumLength6Bits')
            }
          ]
        }
      },
      url: {
        delete: `${MTC_AUTH}sys/sysDepart/delete`,
        edit: `${MTC_AUTH}sys/sysDepart/edit`,
        deleteBatch: `${MTC_AUTH}sys/sysDepart/deleteBatch`,
        exportXlsUrl: `${MTC_AUTH}sys/sysDepart/exportXls`,
        importExcelUrl: `${MTC_AUTH}sys/sysDepart/importExcel`,
        departSnapshot: `${MTC_AUTH}sys/sysDepart/departSnapshot`
      },
      orgCategoryDisabled: false,
      status: false,
      leaderList: [], //负责人
      assignerList: [], //分管领导
      deptAdminList: [],
      addressList: [], //省市县三级地址
      addressDefaultCode: null, //三级地址默认值
      companyShow: false,
      farmTypeList: [], //农场类型
      houseStatusTypeList: [], //当前的状态
      farmOwnershipTypeList: [], //农场属性
      breedModeTypeList: [], //喂养类型
      houseShow: false, //栋舍扩展信息是否显示
      farmOwnershipShow: true, //如果是合作农户时，需要选所属客户
      plantShow: true,
      plantTypeList: [], //工厂类型
      departRefScrollTop: 0,
      departsList: []
    }
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG[ 'domianURL' ]}/${this.url.importExcelUrl}`
    }
  },
  created() {
    this.currFlowId = this.$route.params.id
    this.currFlowName = this.$route.params.name
    this.getLangForm(this.mainTable)
    this.initDepartList()
    // this.loadTree()
  },
  methods: {
    test(e) {
      console.log(e, '获取到啥？')
    },
    initDepartList() {
      ajaxGetDictItems('org_category', null).then((res) => {
        if (res.success) {
          this.departsList = res.result
        }
      })
    },
    // 获取多语言字段 relEntityAttribute
    getLangItem(relTable) {
      relTable && getLanguageField(relTable).then(res => {
        this.tableLangFieldArr = res.fieldArr
        this.$store.commit('SET_TABLELANGFIELD', this.tableLangFieldArr)
      })
    },
    /*validateDesc(rule, value, callback){
        var params = {
            tableName: 'sys_depart',
            fieldName: 'description',
            fieldVal: value,
            dataId: this.model.id
        };
        duplicateCheck(params).then((res) => {
            if (res.success) {
                callback()
            } else {
                callback("机构编码已存在!")
            }
        })
    },*/
    validateDescNew(rule, value, callback) {
      var params = {
        tableName: 'sys_depart',
        fieldName: 'short_code',
        fieldVal: value,
        dataId: this.model.id
      }
      duplicateCheck(params).then((res) => {
        if (res.success) {
          callback()
        } else {
          callback('机构简码已存在!')
        }
      })
    },
    loadData() {
      this.refresh()
    },
    loadTree() {
      var that = this
      if (this.model.shortCode) {
        this.shortCodeBled = true
      } else {
        this.shortCodeBled = false
      }
      if (this.model.description) {
        this.descriptionBled = true
      } else {
        this.descriptionBled = false
      }
      that.treeData = []
      that.departTree = []
      queryDepartTreeList().then((res) => {
        if (res.success) {
          //部门全选后，再添加部门，选中数量增多
          this.allTreeKeys = []
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[ i ]
            that.treeData.push(temp)
            that.departTree.push(temp)
            that.setThisExpandedKeys(temp)
            that.getAllKeys(temp)
            // console.log(temp.id)
          }
          this.loading = false
        }
      })
    },
    setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key)
        for (let a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[ a ])
        }
      }
    },
    refresh() {
      this.loading = true
      this.loadTree()
    },
    // 右键操作方法
    rightHandle(node) {
      this.dropTrigger = 'contextmenu'
      console.log(node.node.eventKey)
      this.rightClickSelectedKey = node.node.eventKey
      this.rightClickSelectedOrgCode = node.node.dataRef.orgCode
    },
    onExpand(expandedKeys) {
      console.log('onExpand', expandedKeys)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.iExpandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    backFlowList() {
      this.$router.back(-1)
    },
    // 右键点击下拉框改变事件
    dropStatus(visible) {
      if (visible == false) {
        this.dropTrigger = ''
      }
    },
    // 右键店家下拉关闭下拉框
    closeDrop() {
      this.dropTrigger = ''
    },
    addRootNode() {
      this.$refs.nodeModal.add(this.currFlowId, '')
    },
    batchDel: function() {
      console.log(this.checkedKeys)
      if (this.checkedKeys.length <= 0) {
        this.$message.warning(this.$t('tip.pleaseSelectARecord'))
      } else {
        var ids = ''
        for (var a = 0; a < this.checkedKeys.length; a++) {
          ids += this.checkedKeys[ a ] + ','
        }
        var that = this
        this.$confirm({
          title: this.$t('tip.confirmDeletion'),
          content: '确定要删除所选中的 ' + this.checkedKeys.length + ' 条数据，以及子节点数据吗?',
          onOk: function() {
            deleteAction(that.url.deleteBatch, { ids: ids }).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.loadTree()
                that.onClearSelected()
              } else {
                that.$message.warning(res.message)
              }
            })
          }
        })
      }
    },
    getAddressDataList() {
      getAddressList().then(res => {
        this.addressList = res.result
      })
    },
    getBreedModeTypeList() {
      ajaxGetDictItems('breed_mode', null).then(res => {
        this.breedModeTypeList = res.result
      })
    },
    getFarmOwnershipTypeList() {
      ajaxGetDictItems('farm_ownership_type', null).then(res => {
        this.farmOwnershipTypeList = res.result
      })
    },
    getHouseStatusTypeList() {
      ajaxGetDictItems('house_status_type', null).then(res => {
        this.houseStatusTypeList = res.result
      })
    },
    getFarmTypeList() {
      ajaxGetDictItems('farm_type', null).then(res => {
        this.farmTypeList = res.result
      })
    },
    onSearch(value) {
      let that = this
      if (value) {
        searchByKeywords({ keyWord: value }).then((res) => {
          if (res.success) {
            that.departTree = []
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[ i ]
              that.departTree.push(temp)
            }
          } else {
            that.$message.warning(res.message)
          }
        })
      } else {
        that.loadTree()
      }

    },
    getPlantTypeList() {
      ajaxGetDictItems('plant_type', null).then(res => {
        this.plantTypeList = res.result
      })
    },
    nodeModalOk() {
      this.loadTree()
    },
    nodeModalClose() {
    },
    hide() {
      console.log(111)
      this.visible = false
    },
    onCheck(checkedKeys, info) {
      console.log('onCheck', checkedKeys, info)
      this.hiding = false
      //this.checkedKeys = checkedKeys.checked
      // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      if (this.checkStrictly) {
        this.checkedKeys = checkedKeys.checked
      } else {
        this.checkedKeys = checkedKeys
      }
      // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
    },
    onSelect(selectedKeys, e) {
      this.hiding = false
      let record = e.node.dataRef
      console.log('onSelect-record', record)
      // 获取所有扩展属性
      this.getTreeNodeInfo(record)
      this.currSelected = Object.assign({}, record)
      this.model = this.currSelected
      this.selectedKeys = [record.key]
      this.model.parentId = record.parentId
      this.setValuesToForm(record)
      this.$refs.departAuth.show(record.id)

    },
    // 查询选中树节点信息
    getTreeNodeInfo({ id }) {
      queryDepartExtend({ id }).then(res => {
        let data = res.result
        if (!data) return
        // 设置省市区数据回显
        if (data?.province) {
          let { province, city, area } = data
          this.area = [province, city, area]
        }
      })
    },
    // 触发onSelect事件时,为部门树右侧的form表单赋值
    setValuesToForm(record) {
      if (record.shortCode) {
        this.shortCodeBled = true
      } else {
        this.shortCodeBled = false
      }
      if (record.description) {
        this.descriptionBled = true
      } else {
        this.descriptionBled = false
      }

      this.status = this.currSelected.status == 1? true: false
      if (record.orgCategory == '1') {
        this.orgCategoryDisabled = true
      } else {
        this.orgCategoryDisabled = false
      }
      /* 初始化负责人和分管领导 */
      this.getUserList()
      // 工厂、养殖场、栋舍扩展数据显示、隐藏
      if (record.orgCategory == '4' || record.orgCategory == '5') {
        if (record.orgCategory == '4') {
          this.plantShow = false
        } else {
          this.plantShow = true
        }
        // 初始化表单
        this.getFarmTypeList()
        // this.getOwnershipList();
        // this.getOrgAttrList();
        this.getHouseStatusTypeList()
        this.getFarmOwnershipTypeList()
        // this.getAddressDataList()
        this.getPlantTypeList()
        // this.plantShow = false
        // queryDepartExtend({ id: record.id }).then((res) => {
        //   this.departExtend = res.result
        //   if (res.result != null) {
        //     if (res.result.addressCode != null) {
        //       this.addressDefaultCode = res.result.addressCode.split(';')
        //     }
        //     if (res.result.ownership === '10') {
        //       this.farmOwnershipShow = false
        //     }
        //   } else {
        //     this.addressDefaultCode = null
        //   }
        //   this.form.getFieldDecorator('addressCode', { initialValue: '' })
        //   this.form.setFieldsValue(pick(this.departExtend, 'emptyHousePeriod', 'costCenter', 'farmOwnership', 'houseStatus', 'ownerSupplier', 'farmType', 'addressCode', 'orgAttr', 'zipCode', 'farmerCode', 'longitude', 'dimension', 'breedArea', 'scale', 'ownership', 'inspector', 'salesManager', 'feedPlantCode', 'cooperEnterprise'))
        // })
        this.houseShow = false
        this.companyShow = false
        this.farmShow = true
      } else if (record.orgCategory == '6') {
        // 初始化养殖方式表单
        this.getBreedModeTypeList()
        // this.getHouseTypeList();
        // this.getBreedSpeciesList();
        // queryDepartExtend({ id: record.id }).then((res) => {
        //   this.departExtend = res.result
        //   this.form.setFieldsValue(pick(this.departExtend, 'houseWidth', 'breedArea', 'houseLength', 'vfanPower', 'hfanPower', 'breedSpeciesCode', 'coverArea', 'houseType', 'breedMode', 'startTime', 'endTime', 'scale'))
        // })
        this.plantShow = true
        this.houseShow = true
        this.farmShow = false
        this.farmOwnershipShow = false
        this.companyShow = false
      } else if (record.orgCategory == '1') {
        // queryDepartExtend({id: record.id}).then((res) => {
        //
        //   this.departExtend = res.result
        //   if (res.result != null) {
        //     if (res.result.addressCode != null) {
        //       this.addressDefaultCode = res.result.addressCode.split(';')
        //     }
        //     if (res.result.farmOwnership === '10') {
        //       this.farmOwnershipShow = false
        //     }
        //   } else {
        //     this.addressDefaultCode = null
        //   }
        //   this.form.getFieldDecorator('addressCode', { initialValue: '' })
        //   this.form.setFieldsValue(
        //     pick(
        //       this.departExtend,
        //       'feedPlantCode',
        //       'costCenter',
        //       'farmType',
        //       'emptyHousePeriod',
        //       'addressCode',
        //       'farmOwnership',
        //       'ownerSupplier',
        //       'houseStatus'
        //     )
        //   )
        // });
        // queryDepartExtend({ id: record.id }).then(res => {
        //   this.departExtend = res.result
        //   this.form.setFieldsValue(pick(this.departExtend, 'uscc'))
        // })
        this.houseShow = false
        this.farmOwnershipShow = false
        this.farmShow = false
        this.companyShow = true
        this.plantShow = true

      } else {
        this.houseShow = false
        this.farmOwnershipShow = false
        this.farmShow = false
        this.companyShow = false
        this.plantShow = true
      }
      this.$nextTick(() => {
        this.form.getFieldDecorator('fax', { initialValue: '' })
        this.form.setFieldsValue(pick(record, 'departName', 'plantType', 'feedPlantCode', 'dimension', 'longitude', 'farmerCode', 'orgCategory', 'orgCode', 'description', 'departOrder', 'mobile', 'fax', 'address', 'memo', 'leaderId', 'assignerId', 'deptAdmin', 'shortCode', 'orgType'))
      })
    },
    getCurrSelectedTitle() {
      return !this.currSelected.title? '': this.currSelected.title
    },
    onClearSelected() {
      this.hiding = true
      this.checkedKeys = []
      this.currSelected = {}
      this.form.resetFields()
      this.selectedKeys = []
      this.$refs.departAuth.departId = ''
    },
    handleNodeTypeChange(val) {
      this.currSelected.nodeType = val
    },
    notifyTriggerTypeChange(value) {
      this.currSelected.notifyTriggerType = value
    },
    receiptTriggerTypeChange(value) {
      this.currSelected.receiptTriggerType = value
    },
    submitCurrForm() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (!this.currSelected.id) {
            this.$message.warning('请点击选择要修改部门!')
            return
          }
          let sysDepart = Object.assign(this.currSelected, values)
          if (sysDepart.orgCategory === '4' || sysDepart.orgCategory === '5') {
            sysDepart.sysDepartExtend = {
              // feedPlantCode: sysDepart.feedPlantCode,
              farmerCode: sysDepart.farmerCode,
              longitude: sysDepart.longitude,
              dimension: sysDepart.dimension,
              costCenter: sysDepart.costCenter,
              farmType: sysDepart.farmType,
              emptyHousePeriod: sysDepart.emptyHousePeriod,
              addressCode: this.addressDefaultCode != null? this.addressDefaultCode.join(';'): null,
              farmOwnership: sysDepart.farmOwnership,
              ownerSupplier: sysDepart.farmOwnership === '20'? sysDepart.ownerSupplier: null,
              houseStatus: sysDepart.houseStatus
            }
          } else if (sysDepart.orgCategory === '6') {
            sysDepart.sysDepartExtend = {
              houseLength: sysDepart.houseLength,
              houseWidth: sysDepart.houseWidth,
              breedMode: sysDepart.breedMode,
              vfanPower: sysDepart.vfanPower,
              hfanPower: sysDepart.hfanPower,
              breedArea: sysDepart.breedArea,
              startTime: sysDepart.startTime,
              endTime: sysDepart.endTime,
              scale: sysDepart.scale
            }
          } else if (sysDepart.orgCategory === '1') {
            sysDepart.sysDepartExtend = {
              uscc: sysDepart.uscc
            }
          }
          sysDepart.status = this.status === true? 1: 0
          let formData = {
            ...sysDepart
          }
          formData.sysLanguageList = setLangInputParams(this.mainTable, formData.id)
          if (this.area?.length) {
            formData = {
              ...formData,
              sysDepartExtend: {
                province: this.area[ 0 ],
                city: this.area[ 1 ],
                area: this.area[ 2 ]
              }
            }
          }
          httpAction(this.url.edit, formData, 'put').then((res) => {
            if (res.success) {
              resetLangFieldMap()
              this.$message.success(this.$t('tip.successfulOperation'))
              this.loadTree()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },
    emptyCurrForm() {
      this.form.resetFields()
    },
    nodeSettingFormSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
        }
      })
    },
    openSelect() {
      this.$refs.sysDirectiveModal.show()
    },
    handleAdd(num) {
      if (num == 1) {
        this.$refs.departModal.add()
        this.$refs.departModal.title = this.$t('button.add')
      } else if (num == 2) {
        let key = this.currSelected.key
        if (!key) {
          this.$message.warning(this.$t('tip.pleaseSelectParentDepartment'))
          return false
        }
        this.$refs.departModal.add(this.selectedKeys)
        this.$refs.departModal.title = this.$t('button.add')
      } else {
        this.$refs.departModal.add(this.rightClickSelectedKey)
        this.$refs.departModal.title = this.$t('button.add')
      }
    },
    handleDelete() {
      var that = this
      this.$confirm({
        title: this.$t('tip.confirmDeletion'),
        content: this.$t('tip.areYouSureDeleteDepartmentAndSubData'),
        onOk: function() {
          deleteByDepartId({ id: that.rightClickSelectedKey }).then((resp) => {
            if (resp.success) {
              //删除成功后，去除已选中中的数据
              that.checkedKeys.splice(
                that.checkedKeys.findIndex((key) => key === that.rightClickSelectedKey),
                1
              )
              that.$message.success(this.$t('tip.successfulOperation'))
              that.loadTree()
              //删除后同步清空右侧基本信息内容
              let orgCode = that.form.getFieldValue('orgCode')
              if (orgCode && orgCode === that.rightClickSelectedOrgCode) {
                that.onClearSelected()
              }
            } else {
              that.$message.warning(this.$t('tip.failureOperation'))
            }
          })
        }
      })
    },
    selectDirectiveOk(record) {
      console.log('选中指令数据', record)
      this.nodeSettingForm.setFieldsValue({ directiveCode: record.directiveCode })
      this.currSelected.sysCode = record.sysCode
    },
    getFlowGraphData(node) {
      this.graphDatasource.nodes.push({
        id: node.id,
        text: node.flowNodeName
      })
      if (node.children.length > 0) {
        for (let a = 0; a < node.children.length; a++) {
          let temp = node.children[ a ]
          this.graphDatasource.edges.push({
            source: node.id,
            target: temp.id
          })
          this.getFlowGraphData(temp)
        }
      }
    },
    // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
    expandAll() {
      this.iExpandedKeys = this.allTreeKeys
    },
    closeAll() {
      this.iExpandedKeys = []
    },
    checkALL() {
      this.checkStriccheckStrictlytly = false
      this.checkedKeys = this.allTreeKeys
    },
    cancelCheckALL() {
      //this.checkedKeys = this.defaultCheckedKeys
      this.checkedKeys = []
    },
    getUserList() {
      getAllUserList().then((res) => {
        this.leaderList = res.result
        this.assignerList = res.result
        this.deptAdminList = res.result
      })
    },
    switchCheckStrictly(v) {
      if (v == 1) {
        this.checkStrictly = false
      } else if (v == 2) {
        this.checkStrictly = true
      }
    },
    getAllKeys(node) {
      // console.log('node',node);
      this.allTreeKeys.push(node.key)
      if (node.children && node.children.length > 0) {
        for (let a = 0; a < node.children.length; a++) {
          this.getAllKeys(node.children[ a ])
        }
      }
    },
    // <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
    showModal() {
      this.visible = true
    },
    handleOk(e) {
      httpAction(this.url.departSnapshot, '', 'post').then((res) => {
        console.log(res)
        console.log(res.success)

        if (res.success) {
          this.$message.success(this.$t('tip.successfulOperation'))
          this.loadTree()
        } else {
          this.$message.error(res.message)
        }
      })
      this.visible = false
    },
    farmOwnershipChange(e) {
      if (e.target.value === '20') {
        this.farmOwnershipShow = true
      } else {
        this.farmOwnershipShow = false
      }
    }
  }
}
</script>

<style scoped>
.ant-card-body .table-operator {
  margin: 15px;
}

.anty-form-btn {
  width: 100%;
  text-align: center;
}

.anty-form-btn button {
  margin: 0 5px;
}

.anty-node-layout .ant-layout-header {
  padding-right: 0;
}

.header {
  padding: 0 8px;
}

.header button {
  margin: 0 3px;
}

.ant-modal-cust-warp {
  height: 100%;
}

.ant-modal-cust-warp .ant-modal-body {
  height: calc(100% - 110px) !important;
  overflow-y: auto;
}

.ant-modal-cust-warp .ant-modal-content {
  height: 90% !important;
  overflow-y: hidden;
}

#app .desktop {
  height: auto !important;
}

/** Button按钮间距 */
.ant-btn {
  margin-left: 3px;
}

.drawer-bootom-button {
  /*position: absolute;*/
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>